"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "EasyAddFormConfigModel", {
    enumerable: true,
    get: function() {
        return EasyAddFormConfigModel;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const EasyAddFormConfigModel = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    allow_comments: _zod.z.boolean().optional(),
    appendedToTemplate: _zod.z.boolean().optional(),
    approval: _zod.z.boolean().optional(),
    author_due_date: _zod.z.union([
        _zod.z.string(),
        _zod.z.number()
    ]),
    company: _zod.z.instanceof(_bson.ObjectId),
    created_at: _zod.z.date(),
    deleted_at: _zod.z.union([
        _zod.z.date(),
        _zod.z.null(),
        _zod.z.string()
    ]).optional(),
    due_date_types: _zod.z.string(),
    formID: _zod.z.instanceof(_bson.ObjectId),
    formObject: _zod.z.object({}).optional(),
    is_active: _zod.z.boolean(),
    isNewForm: _zod.z.boolean().optional(),
    modified_at: _zod.z.date(),
    redact: _zod.z.boolean(),
    requiresApproval: _zod.z.enum([
        "manager_and_admins",
        "admins-only"
    ]).optional(),
    signer_due_date: _zod.z.union([
        _zod.z.string(),
        _zod.z.number()
    ]),
    subject_employee_choose_author: _zod.z.enum([
        "anyEmployee",
        "self"
    ]).optional(),
    type: _zod.z.enum([
        "easyAdd",
        "basic",
        "external"
    ]).optional(),
    unsaved: _zod.z.boolean().optional(),
    visibility: _zod.z.boolean(),
    who_can_add_form: _zod.z.object({
        admin_or_group_admin: _zod.z.boolean(),
        any_employee: _zod.z.boolean(),
        manager_or_chain_of_command: _zod.z.boolean(),
        subject: _zod.z.boolean()
    }),
    who_signs_off: _zod.z.array(_zod.z.object({
        id: _zod.z.string(),
        name: _zod.z.string()
    }))
});
